import { render, staticRenderFns } from "./CustomerColumn.vue?vue&type=template&id=73fd21f4&"
import script from "./CustomerColumn.vue?vue&type=script&lang=js&"
export * from "./CustomerColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports